<div class="options-management-container">

  <h3><span class="back-link" (click)="returnOnOfferSelection()" translate>T_OFFER_DATA_MANAGEMENT_BACK_BUTTON</span>
  </h3>

  <div>
    <div class="titles">
      <p class="range-key" translate><span
        translate>T_OFFER_DATA_MANAGEMENT_OPTIONS_LIST_OF_REFERENCES_OF_RANGE </span>{{ selectedRange.nameKey }}</p>
    </div>
  </div>

  <div *ngIf="!isLoading">
    <div class="button-container">
      <input [(ngModel)]="searchValue" (ngModelChange)="searchInputChanged()" [placeholder]="searchPlaceholder"/>
      <button class="btn btn-smart btn-gray" (click)="onClickAddAssociationOptionButton()" translate>
        <span class="se-icons">action_add_stroke</span>T_OPTION_ASSOCIATE_BUTTON
      </button>
      <button class="btn btn-smart btn-gray" (click)="onClickExportOptionsButton()" translate>
        <span class="se-icons">action_download</span>T_PRICE_EXPORT
      </button>
      <app-spinner *ngIf="isExportLoading" [vCenter]="false" [sizeClass]="'extra-small'"></app-spinner>
    </div>

    <h6 *ngIf="searchValue && displayedReferences.length === 0" translate>T_SEARCH_NO_MATCH</h6>

    <div class="options-list">
      <app-odm-options-list-references
        [selectedRange]="selectedRange"
        [references]="displayedReferences"
        [options]="optionsByReference"
        [activeOption]="activeOption"
        (clickEditCategoryName)="onEditCategoryName($event)"
        (clickEditCategoryAssociation)="onEditCategoryAssociation($event)"
        (clickDeleteCategoryAssociation)="onDeleteCategoryAssociation($event)"
        (changeCategoryOrderEvent)="onChangeCategoryOrder($event)"
        (changeOptionOrderEvent)="onChangeOptionOrder($event)">
      </app-odm-options-list-references>
    </div>
    <div *ngIf="isLoading" class="odm-left-column">
      <app-spinner [sizeClass]="'large'"></app-spinner>
    </div>
  </div>

  <app-odm-associate-option-modal
    #associateOptionModal
    (associateOption)="associateOptions($event)"
    (deleteCategoryAssociation)="onDeleteCategoryConfirmed($event)"
    [rangeId]="selectedRange.id">
  </app-odm-associate-option-modal>
